jQuery(document).ready(function($){
  var heightFilter = 0, topFilter = 0;
  $('.collection-wrapper .open-filter').click(function(){
    if($(window).scrollTop() > 30){
      topFilter = $('.Header .Header__Wrapper').height();
      heightFilter = '100vh - ' + topFilter + 'px';
    }
    else{
      topFilter = $('.Header .Header__Wrapper').height() + $('.AnnouncementBar').height()
      heightFilter = '100vh - '+ topFilter + 'px';
    }
    $('.collection-wrapper').addClass('openSidebar');
    $('body').addClass('no-scroll');
    $('.collection-wrapper .CollectionFilters').css('height','calc('+heightFilter+')');
  })

  $('.collection-wrapper .CollectionFilters .filter-title .close-filter').click(function(){
    $('.collection-wrapper').removeClass('openSidebar');
    $('body').removeClass('no-scroll');
  })
  $('.filter-title h2').click(function(){
    $('.collection-wrapper').removeClass('openSidebar');
    $('body').removeClass('no-scroll');
  })
  $(document).mouseup(function(e) {
    var container = $(".CollectionFilters");
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
      $('.collection-wrapper').removeClass('openSidebar');
      $('body').removeClass('no-scroll');
    }
  });
  $(document).on('keyup',function(e) {
    if (e.keyCode == 27) {
      $('.collection-wrapper').removeClass('openSidebar');3
      $('body').removeClass('no-scroll');
    }
  });



  //   	$('html').click(function(event) {
  //         if ($(event.target).closest('.CollectionFilters,.collection-wrapper .open-filter').length === 0) {
  //             $('.collection-wrapper').removeClass('openSidebar')
  //         }
  //     });
})